const radius = Object.freeze({
  '4': 4,
  '6': 6,
  '8': 8,
  '12': 12,
  '16': 16,
  '20': 20,
  '24': 24,
  full: 9999,
})

type Radius = keyof typeof radius

export { radius }
export type { Radius }
